export default "__VITE_ASSET__d95476fc__"